module.exports = __webpack_public_path__ + "img/videoimg3.c9fb8547.png";